import type { StreamSource } from "@tih/shared";
import {
  YOUTUBE_THUMBNAIL_MIN_WIDTH,
  YOUTUBE_THUMBNAIL_QUALITIES,
  youtubeThumbnailUrl,
} from "@tih/shared";

function probeImageMinWidth(url: string, minWidth: number): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img.naturalWidth >= minWidth);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

/** First available YouTube still for `videoId`, or `fallbackPoster` when none exist. */
export async function resolveYoutubeStreamPoster(
  videoId: string,
  fallbackPoster: string | null,
): Promise<string | null> {
  const id = videoId.trim();
  if (!id) return fallbackPoster;

  for (const quality of YOUTUBE_THUMBNAIL_QUALITIES) {
    const url = youtubeThumbnailUrl(id, quality);
    const ok = await probeImageMinWidth(url, YOUTUBE_THUMBNAIL_MIN_WIDTH[quality]);
    if (ok) return url;
  }

  return fallbackPoster;
}

/** Resolve a poster/thumbnail for any stream source. */
export async function resolveStreamPoster(
  source: StreamSource,
  fallbackPoster: string | null,
): Promise<string | null> {
  if (source.kind === "youtube") {
    return resolveYoutubeStreamPoster(source.src, fallbackPoster);
  }
  return fallbackPoster ?? source.poster ?? null;
}
